import get from 'lodash/get'
import React from 'react'
import type { RedirectProps } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import { useClientOptions, useUser } from '@paintscout/ui-business'

export interface RedirectHomeProps extends Omit<RedirectProps, 'to'> {}

/**
 * Redirects to either /dashboard or /quotes, depending on features & profile settings
 */
export default function RedirectHome(props: RedirectHomeProps) {
  const { options } = useClientOptions()
  const { profile } = useUser()

  const hasDashboard = get(options, 'options.features.dashboard.enabled', false)
  const homePage = get(profile, 'preferences.homePage', hasDashboard ? 'dashboard' : 'quotes')

  return <Redirect to={`/${homePage}/`} {...props} />
}
